export const PAYMENT_STATUS_LABELS = {
  outstanding: 'Outstanding',
  partially_paid: 'Partially paid',
  fully_paid: 'Fully paid',
};

export function paymentStatusBadgeClass(status) {
  if (status === 'fully_paid') return 'bg-emerald-500/25 text-emerald-200 border-emerald-500/40';
  if (status === 'partially_paid') return 'bg-amber-500/25 text-amber-100 border-amber-500/40';
  return 'bg-red-500/25 text-red-200 border-red-500/40';
}
